"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsHoliday = exports.getNightHours = exports.getIsLateNight = exports.getIsNight = exports.getIsWeekend = exports.getIsSunday = exports.getIsSaturday = exports.getWorkTimeType = exports.getIsOvertime = exports.getIsDoubleTime = exports.getIsTimeAndOneHalf = exports.getIsStraightTime = void 0;
const types_1 = require("@shared/types");
const dayjs_1 = __importDefault(require("dayjs"));
const session_helpers_1 = require("./session-helpers");
const MS_PER_HOUR = 1000 * 60 * 60;
/**
 * Work Time Types by Hours
 */
const getIsStraightTime = (hours) => hours > 0 && hours <= 8;
exports.getIsStraightTime = getIsStraightTime;
const getIsTimeAndOneHalf = (hours) => hours > 8 && hours <= 10;
exports.getIsTimeAndOneHalf = getIsTimeAndOneHalf;
const getIsDoubleTime = (hours) => hours > 10;
exports.getIsDoubleTime = getIsDoubleTime;
const getIsOvertime = (hours) => (0, exports.getIsTimeAndOneHalf)(hours) || (0, exports.getIsDoubleTime)(hours);
exports.getIsOvertime = getIsOvertime;
const getWorkTimeType = (hours, totalMultiplier) => {
    if ((0, exports.getIsTimeAndOneHalf)(hours))
        return types_1.WorkTimeType.TimeAndOneHalf;
    else if ((0, exports.getIsDoubleTime)(hours))
        return totalMultiplier && totalMultiplier + 1 > 2
            ? types_1.WorkTimeType.TimeAndOneHalf
            : types_1.WorkTimeType.DoubleTime;
    else
        return types_1.WorkTimeType.StraightTime;
};
exports.getWorkTimeType = getWorkTimeType;
/**
 * Day of Week
 *
 * Note: moment's `.weekday()` is locale-aware; dayjs's `.day()` is not. Since neither
 * moment nor dayjs ever has a non-default locale set anywhere in this codebase, moment's
 * default `'en'` locale (week starts Sunday) makes `.weekday()` numerically identical to
 * `.day()` here (Sunday=0…Saturday=6), so this is a literal substitution, not an
 * approximation.
 */
const getIsSaturday = (date) => (dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date)).day() === 6;
exports.getIsSaturday = getIsSaturday;
const getIsSunday = (date) => (dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date)).day() === 0;
exports.getIsSunday = getIsSunday;
const getIsWeekend = (date) => (0, exports.getIsSaturday)(date) || (0, exports.getIsSunday)(date);
exports.getIsWeekend = getIsWeekend;
/**
 * Time of Day
 */
const getIsNight = (role, date) => {
    const currentHour = (dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date)).hour();
    return ((currentHour >= 20 && currentHour < 24) ||
        (currentHour >= 0 &&
            currentHour < ((0, session_helpers_1.getIsExtra)(role.performer_type) ? 1 : 6)));
};
exports.getIsNight = getIsNight;
const getIsLateNight = (role, date) => {
    const currentHour = (dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date)).hour();
    return (0, session_helpers_1.getIsExtra)(role.performer_type)
        ? currentHour >= 1 && currentHour < 6
        : false;
};
exports.getIsLateNight = getIsLateNight;
const getNightHours = (activity) => {
    const nightStart = (0, dayjs_1.default)(activity.start_time)
        .hour(20)
        .minute(0)
        .second(0)
        .millisecond(0);
    return (0, dayjs_1.default)(activity.end_time).diff(nightStart) / MS_PER_HOUR;
};
exports.getNightHours = getNightHours;
/**
 * Holidays
 */
const getIsHoliday = (date) => {
    date = dayjs_1.default.isDayjs(date) ? date : (0, dayjs_1.default)(date);
    let isHoliday = false;
    const month = date.month();
    const day = date.day();
    // See the Day of Week note above - `.day()` is the correct dayjs equivalent of moment's
    // locale-aware `.weekday()` given this codebase never customizes locale.
    const weekday = date.day();
    if (types_1.holidayDates[month]) {
        types_1.holidayDates[month].forEach((holiday) => {
            if (holiday.day && holiday.day === day)
                isHoliday = true;
            else if (holiday.days) {
                if (day >= holiday.days[0] &&
                    day <= holiday.days[1] &&
                    holiday.weekday === weekday)
                    isHoliday = true;
            }
        });
    }
    return isHoliday;
};
exports.getIsHoliday = getIsHoliday;
//# sourceMappingURL=estimate-helpers.js.map